import { getStore } from 'redux/store';
import { selectAdminId, selectUserDetails } from 'redux/user/user.selectors';

export const getAdminId = () => selectAdminId(getStore().getState());
export const getUserDetails = () => selectUserDetails(getStore().getState());
